<template>
    <div class="page--home d-flex align-items-center justify-content-center">
        <div class="bandeirolabg"></div>
        <b-container class="d-flex justify-content-center align-items-center mt-5">
            <b-row class="d-flex justify-content-center align-items-start">
                <b-col cols="12" class="d-flex justify-content-center align-items-center flex-column motionFadeIn">
                    <div class="wrapper-home">
                        <div class="wrap wrap--left me-md-5">
                            <img
                                class="big-mob pulse"
                                src="absoluto/assets/images/home/logo-1.webp?t=3"
                                :alt='promo'
                                :title='promo'
                            >
                            <img
                                class="big-mob"
                                src="absoluto/assets/images/home/logo-2.webp?t=3"
                                :alt='promo'
                                :title='promo'
                            >
                        </div>
                        <div class="wrap wrap--right mt-5 mt-md-0  ms-md-5">
                            <img
                                src="absoluto/assets/images/home/home-premios.webp?t=3"
                                :alt='premio'
                                :title='premio'
                            >
                            <b-button class="mt-5 btn--large" @click="$router.push({ path: `/login` })">
                                Participe
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </b-container>

    </div>
</template>

<script>

    export default {
        name: "HomePage",
        data() {
            return {
                promo: 'Promoção arraial completo só com Yoki',
                premio: 'Compre produtos Yoki, concorra todos os dias a R$ 1.000 em certificado de ouro',
            };
        },
        components: {
        },
    };
</script>

<style lang="scss" scoped>
    @import "../assets/scss/global";
    @import "../assets/scss/onepage";

    .bandeirolabg {
        width: 100%;
        background-image: url(absoluto/assets/images/home/bandeirola.webp);
        background-repeat: repeat-x;
        animation: moveCenterX 3s infinite linear;
        height: 100px;
        position: absolute;
        top: 0px;
    }

    .page--home{
        @media (max-width: 768px) {
            padding-top: 5rem !important;
        }
        padding-top: 3rem !important;
        min-height: inherit;
        .wrapper-home{
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-flow: row nowrap;
            .wrap{
                display: flex;
                flex-flow: column;
                justify-content: center;
                align-items: flex-start;
                &--left {
                    position: relative;
                }
            }
        }
    }

    @media (max-width: $mobile) , (orientation:portrait) {
        .bandeirolabg {
            background-size: 85%;
            width: 120%;
        }
        .page--home {
            padding-bottom: $paddingMobileInternas;
            .wrapper-home{
                flex-flow: column;
                justify-content: center;
                .wrap{
                    img{
                        max-width: 85%;
                        margin: 0 auto;
                        //min-width: 300px;
                    }
                    &--left{
                        margin-bottom: 30px;
                    }
                    &--right{
                        margin-top: 0 !important;
                    }
                }
            }
        }
    }
</style>
